define([
  'immutable',
], function(Immutable) {
  const countries = [
    { country: "Afghanistan", ctry: "AF", spellings: "AF افغانستان" },
    { country: "Åland Islands", ctry: "AX", spellings: "AX Aaland Aland", booster: "0.5" },
    { country: "Albania", ctry: "AL", spellings: "AL" },
    { country: "Algeria", ctry: "DZ", spellings: "DZ الجزائر" },
    { country: "American Samoa", ctry: "AS", spellings: "AS", booster: "0.5" },
    { country: "Andorra", ctry: "AD", spellings: "AD", booster: "0.5" },
    { country: "Angola", ctry: "AO", spellings: "AO" },
    { country: "Anguilla", ctry: "AI", spellings: "AI", booster: "0.5" },
    { country: "Antarctica", ctry: "AQ", spellings: "AQ", booster: "0.5" },
    { country: "Antigua And Barbuda", ctry: "AG", spellings: "AG", booster: "0.5" },
    { country: "Argentina", ctry: "AR", spellings: "AR" },
    { country: "Armenia", ctry: "AM", spellings: "AM Հայաստան" },
    { country: "Aruba", ctry: "AW", spellings: "AW", booster: "0.5" },
    { country: "Australia", ctry: "AU", spellings: "AU", booster: "1.5" },
    { country: "Austria", ctry: "AT", spellings: "AT Österreich Osterreich Oesterreich " },
    { country: "Azerbaijan", ctry: "AZ", spellings: "AZ" },
    { country: "Bahamas", ctry: "BS", spellings: "BS" },
    { country: "Bahrain", ctry: "BH", spellings: "BH البحرين" },
    { country: "Bangladesh", ctry: "BD", spellings: "BD বাংলাদেশ", booster: "2" },
    { country: "Barbados", ctry: "BB", spellings: "BB" },
    { country: "Belarus", ctry: "BY", spellings: "BY Беларусь" },
    { country: "Belgium", ctry: "BE", spellings: "BE België Belgie Belgien Belgique", booster: "1.5" },
    { country: "Belize", ctry: "BZ", spellings: "BZ" },
    { country: "Benin", ctry: "BJ", spellings: "BJ" },
    { country: "Bermuda", ctry: "BM", spellings: "BM", booster: "0.5" },
    { country: "Bhutan", ctry: "BT", spellings: "BT भूटान" },
    { country: "Bolivia", ctry: "BO", spellings: "BO" },
    { country: "Bonaire, Sint Eustatius and Saba", ctry: "BQ", spellings: "BQ" },
    { country: "Bosnia and Herzegovina", ctry: "BA", spellings: "BA BiH Bosna i Hercegovina Босна и Херцеговина" },
    { country: "Botswana", ctry: "BW", spellings: "BW" },
    { country: "Bouvet Island", ctry: "BV", spellings: "BV" },
    { country: "Brazil", ctry: "BR", spellings: "BR Brasil", booster: "2" },
    { country: "British Indian Ocean Territory", ctry: "IO", spellings: "IO" },
    { country: "Brunei Darussalam", ctry: "BN", spellings: "BN" },
    { country: "Bulgaria", ctry: "BG", spellings: "BG България" },
    { country: "Burkina Faso", ctry: "BF", spellings: "BF" },
    { country: "Burundi", ctry: "BI", spellings: "BI" },
    { country: "Cambodia", ctry: "KH", spellings: "KH កម្ពុជា" },
    { country: "Cameroon", ctry: "CM", spellings: "CM" },
    { country: "Canada", ctry: "CA", spellings: "CA", booster: "2" },
    { country: "Cape Verde", ctry: "CV", spellings: "CV Cabo" },
    { country: "Cayman Islands", ctry: "KY", spellings: "KY", booster: "0.5" },
    { country: "Central African Republic", ctry: "CF", spellings: "CF" },
    { country: "Chad", ctry: "TD", spellings: "TD تشاد‎ Tchad" },
    { country: "Chile", ctry: "CL", spellings: "CL" },
    { country: "China", booster: "3.5", ctry: "CN", spellings: "CN Zhongguo Zhonghua Peoples Republic 中国/中华" },
    { country: "Christmas Island", ctry: "CX", spellings: "CX", booster: "0.5" },
    { country: "Cocos (Keeling) Islands", ctry: "CC", spellings: "CC", booster: "0.5" },
    { country: "Colombia", ctry: "CO", spellings: "CO" },
    { country: "Comoros", ctry: "KM", spellings: "KM جزر القمر" },
    { country: "Congo", ctry: "CG", spellings: "CG" },
    { country: "Congo, the Democratic Republic of the", ctry: "CD", spellings: "CD Congo-Brazzaville Repubilika ya Kongo" },
    { country: "Cook Islands", ctry: "CK", spellings: "CK", booster: "0.5" },
    { country: "Costa Rica", ctry: "CR", spellings: "CR" },
    { country: "Côte d'Ivoire", ctry: "CI", spellings: "CI Cote dIvoire" },
    { country: "Croatia", ctry: "HR", spellings: "HR Hrvatska" },
    { country: "Cuba", ctry: "CU", spellings: "CU" },
    { country: "Curaçao", ctry: "CW", spellings: "CW Curacao" },
    { country: "Cyprus", ctry: "CY", spellings: "CY Κύπρος Kýpros Kıbrıs" },
    { country: "Czech Republic", ctry: "CZ", spellings: "CZ Česká Ceska" },
    { country: "Denmark", ctry: "DK", spellings: "DK Danmark", booster: "1.5" },
    { country: "Djibouti", ctry: "DJ", spellings: "DJ جيبوتي‎ Jabuuti Gabuuti" },
    { country: "Dominica", ctry: "DM", spellings: "DM Dominique", booster: "0.5" },
    { country: "Dominican Republic", ctry: "DO", spellings: "DO" },
    { country: "Ecuador", ctry: "EC", spellings: "EC" },
    { country: "Egypt", ctry: "EG", spellings: "EG", booster: "1.5" },
    { country: "El Salvador", ctry: "SV", spellings: "SV" },
    { country: "Equatorial Guinea", ctry: "GQ", spellings: "GQ" },
    { country: "Eritrea", ctry: "ER", spellings: "ER إرتريا ኤርትራ" },
    { country: "Estonia", ctry: "EE", spellings: "EE Eesti" },
    { country: "Ethiopia", ctry: "ET", spellings: "ET ኢትዮጵያ" },
    { country: "Falkland Islands (Malvinas)", ctry: "FK", spellings: "FK", booster: "0.5" },
    { country: "Faroe Islands", ctry: "FO", spellings: "FO Føroyar Færøerne", booster: "0.5" },
    { country: "Fiji", ctry: "FJ", spellings: "FJ Viti फ़िजी" },
    { country: "Finland", ctry: "FI", spellings: "FI Suomi" },
    { country: "France", ctry: "FR", spellings: "FR République française", booster: "2.5" },
    { country: "French Guiana", ctry: "GF", spellings: "GF" },
    { country: "French Polynesia", ctry: "PF", spellings: "PF Polynésie française" },
    { country: "French Southern Territories", ctry: "TF", spellings: "TF" },
    { country: "Gabon", ctry: "GA", spellings: "GA République Gabonaise" },
    { country: "Gambia", ctry: "GM", spellings: "GM" },
    { country: "Georgia", ctry: "GE", spellings: "GE საქართველო" },
    { country: "Germany", ctry: "DE", spellings: "DE Bundesrepublik Deutschland", booster: "3" },
    { country: "Ghana", ctry: "GH", spellings: "GH" },
    { country: "Gibraltar", ctry: "GI", spellings: "GI", booster: "0.5" },
    { country: "Greece", ctry: "GR", spellings: "GR Ελλάδα", booster: "1.5" },
    { country: "Greenland", ctry: "GL", spellings: "GL grønland", booster: "0.5" },
    { country: "Grenada", ctry: "GD", spellings: "GD" },
    { country: "Guadeloupe", ctry: "GP", spellings: "GP" },
    { country: "Guam", ctry: "GU", spellings: "GU" },
    { country: "Guatemala", ctry: "GT", spellings: "GT" },
    { country: "Guernsey", ctry: "GG", spellings: "GG", booster: "0.5" },
    { country: "Guinea", ctry: "GN", spellings: "GN" },
    { country: "Guinea-Bissau", ctry: "GW", spellings: "GW" },
    { country: "Guyana", ctry: "GY", spellings: "GY" },
    { country: "Haiti", ctry: "HT", spellings: "HT" },
    { country: "Heard Island and McDonald Islands", ctry: "HM", spellings: "HM" },
    { country: "Holy See (Vatican City State)", ctry: "VA", spellings: "VA", booster: "0.5" },
    { country: "Honduras", ctry: "HN", spellings: "HN" },
    { country: "Hong Kong", ctry: "HK", spellings: "HK 香港" },
    { country: "Hungary", ctry: "HU", spellings: "HU Magyarország" },
    { country: "Iceland", ctry: "IS", spellings: "IS Island" },
    { country: "India", ctry: "IN", spellings: "IN भारत गणराज्य Hindustan", booster: "3" },
    { country: "Indonesia", ctry: "ID", spellings: "ID", booster: "2" },
    { country: "Iran, Islamic Republic of", ctry: "IR", spellings: "IR ایران" },
    { country: "Iraq", ctry: "IQ", spellings: "IQ العراق‎" },
    { country: "Ireland", ctry: "IE", spellings: "IE Éire", booster: "1.2" },
    { country: "Isle of Man", ctry: "IM", spellings: "IM", booster: "0.5" },
    { country: "Israel", ctry: "IL", spellings: "IL إسرائيل ישראל" },
    { country: "Italy", ctry: "IT", spellings: "IT Italia", booster: "2" },
    { country: "Jamaica", ctry: "JM", spellings: "JM" },
    { country: "Japan", ctry: "JP", spellings: "JP Nippon Nihon 日本", booster: "2.5" },
    { country: "Jersey", ctry: "JE", spellings: "JE", booster: "0.5" },
    { country: "Jordan", ctry: "JO", spellings: "JO الأردن" },
    { country: "Kazakhstan", ctry: "KZ", spellings: "KZ Қазақстан Казахстан" },
    { country: "Kenya", ctry: "KE", spellings: "KE" },
    { country: "Kiribati", ctry: "KI", spellings: "KI" },
    { country: "Korea, Democratic People's Republic of", ctry: "KP", spellings: "KP North Korea" },
    { country: "Korea, Republic of", ctry: "KR", spellings: "KR South Korea", booster: "1.5" },
    { country: "Kuwait", ctry: "KW", spellings: "KW الكويت" },
    { country: "Kyrgyzstan", ctry: "KG", spellings: "KG Кыргызстан" },
    { country: "Lao People's Democratic Republic", ctry: "LA", spellings: "LA" },
    { country: "Latvia", ctry: "LV", spellings: "LV Latvija" },
    { country: "Lebanon", ctry: "LB", spellings: "LB لبنان" },
    { country: "Lesotho", ctry: "LS", spellings: "LS" },
    { country: "Liberia", ctry: "LR", spellings: "LR" },
    { country: "Libyan Arab Jamahiriya", ctry: "LY", spellings: "LY ليبيا" },
    { country: "Liechtenstein", ctry: "LI", spellings: "LI" },
    { country: "Lithuania", ctry: "LT", spellings: "LT Lietuva" },
    { country: "Luxembourg", ctry: "LU", spellings: "LU" },
    { country: "Macao", ctry: "MO", spellings: "MO" },
    { country: "Macedonia, The Former Yugoslav Republic Of", ctry: "MK", spellings: "MK Македонија" },
    { country: "Madagascar", ctry: "MG", spellings: "MG Madagasikara" },
    { country: "Malawi", ctry: "MW", spellings: "MW" },
    { country: "Malaysia", ctry: "MY", spellings: "MY" },
    { country: "Maldives", ctry: "MV", spellings: "MV" },
    { country: "Mali", ctry: "ML", spellings: "ML" },
    { country: "Malta", ctry: "MT", spellings: "MT" },
    { country: "Marshall Islands", ctry: "MH", spellings: "MH", booster: "0.5" },
    { country: "Martinique", ctry: "MQ", spellings: "MQ" },
    { country: "Mauritania", ctry: "MR", spellings: "MR الموريتانية" },
    { country: "Mauritius", ctry: "MU", spellings: "MU" },
    { country: "Mayotte", ctry: "YT", spellings: "YT" },
    { country: "Mexico", ctry: "MX", spellings: "MX Mexicanos", booster: "1.5" },
    { country: "Micronesia, Federated States of", ctry: "FM", spellings: "FM" },
    { country: "Moldova, Republic of", ctry: "MD", spellings: "MD" },
    { country: "Monaco", ctry: "MC", spellings: "MC" },
    { country: "Mongolia", ctry: "MN", spellings: "MN Mongγol ulus Монгол улс" },
    { country: "Montenegro", ctry: "ME", spellings: "ME" },
    { country: "Montserrat", ctry: "MS", spellings: "MS", booster: "0.5" },
    { country: "Morocco", ctry: "MA", spellings: "MA المغرب" },
    { country: "Mozambique", ctry: "MZ", spellings: "MZ Moçambique" },
    { country: "Myanmar", ctry: "MM", spellings: "MM" },
    { country: "Namibia", ctry: "NA", spellings: "NA Namibië" },
    { country: "Nauru", ctry: "NR", spellings: "NR Naoero", booster: "0.5" },
    { country: "Nepal", ctry: "NP", spellings: "NP नेपाल" },
    { country: "Netherlands", ctry: "NL", spellings: "NL Holland Nederland", booster: "1.5" },
    { country: "New Caledonia", ctry: "NC", spellings: "NC", booster: "0.5" },
    { country: "New Zealand", ctry: "NZ", spellings: "NZ Aotearoa" },
    { country: "Nicaragua", ctry: "NI", spellings: "NI" },
    { country: "Niger", ctry: "NE", spellings: "NE Nijar" },
    { country: "Nigeria", ctry: "NG", spellings: "NG Nijeriya Naíjíríà", booster: "1.5" },
    { country: "Niue", ctry: "NU", spellings: "NU", booster: "0.5" },
    { country: "Norfolk Island", ctry: "NF", spellings: "NF", booster: "0.5" },
    { country: "Northern Mariana Islands", ctry: "MP", spellings: "MP", booster: "0.5" },
    { country: "Norway", ctry: "NO", spellings: "NO Norge Noreg", booster: "1.5" },
    { country: "Oman", ctry: "OM", spellings: "OM عمان" },
    { country: "Pakistan", ctry: "PK", spellings: "PK پاکستان", booster: "2" },
    { country: "Palau", ctry: "PW", spellings: "PW", booster: "0.5" },
    { country: "Palestinian Territory, Occupied", ctry: "PS", spellings: "PS فلسطين" },
    { country: "Panama", ctry: "PA", spellings: "PA" },
    { country: "Papua New Guinea", ctry: "PG", spellings: "PG" },
    { country: "Paraguay", ctry: "PY", spellings: "PY" },
    { country: "Peru", ctry: "PE", spellings: "PE" },
    { country: "Philippines", ctry: "PH", spellings: "PH Pilipinas", booster: "1.5" },
    { country: "Pitcairn", ctry: "PN", spellings: "PN", booster: "0.5" },
    { country: "Poland", ctry: "PL", spellings: "PL Polska", booster: "1.25" },
    { country: "Portugal", ctry: "PT", spellings: "PT Portuguesa", booster: "1.5" },
    { country: "Puerto Rico", ctry: "PR", spellings: "PR" },
    { country: "Qatar", ctry: "QA", spellings: "QA قطر" },
    { country: "Réunion", ctry: "RE", spellings: "RE Reunion" },
    { country: "Romania", ctry: "RO", spellings: "RO Rumania Roumania România" },
    { country: "Russian Federation", ctry: "RU", spellings: "RU Rossiya Российская Россия", booster: "2.5" },
    { country: "Rwanda", ctry: "RW", spellings: "RW" },
    { country: "Saint Barthélemy", ctry: "BL", spellings: "BL St. Barthelemy" },
    { country: "Saint Helena", ctry: "SH", spellings: "SH St." },
    { country: "Saint Kitts and Nevis", ctry: "KN", spellings: "KN St." },
    { country: "Saint Lucia", ctry: "LC", spellings: "LC St." },
    { country: "Saint Martin (French Part)", ctry: "MF", spellings: "MF St." },
    { country: "Saint Pierre and Miquelon", ctry: "PM", spellings: "PM St." },
    { country: "Saint Vincent and the Grenadines", ctry: "VC", spellings: "VC St." },
    { country: "Samoa", ctry: "WS", spellings: "WS" },
    { country: "San Marino", ctry: "SM", spellings: "SM RSM Repubblica" },
    { country: "Sao Tome and Principe", ctry: "ST", spellings: "ST" },
    { country: "Saudi Arabia", ctry: "SA", spellings: "SA السعودية" },
    { country: "Senegal", ctry: "SN", spellings: "SN Sénégal" },
    { country: "Serbia", ctry: "RS", spellings: "RS Србија Srbija" },
    { country: "Seychelles", ctry: "SC", spellings: "SC", booster: "0.5" },
    { country: "Sierra Leone", ctry: "SL", spellings: "SL" },
    { country: "Singapore", ctry: "SG", spellings: "SG Singapura  சிங்கப்பூர் குடியரசு 新加坡共和国" },
    { country: "Sint Maarten (Dutch Part)", ctry: "SX", spellings: "SX" },
    { country: "Slovakia", ctry: "SK", spellings: "SK Slovenská Slovensko" },
    { country: "Slovenia", ctry: "SI", spellings: "SI Slovenija" },
    { country: "Solomon Islands", ctry: "SB", spellings: "SB" },
    { country: "Somalia", ctry: "SO", spellings: "SO الصومال" },
    { country: "South Africa", ctry: "ZA", spellings: "ZA RSA Suid-Afrika" },
    { country: "South Georgia and the South Sandwich Islands", ctry: "GS", spellings: "GS" },
    { country: "South Sudan", ctry: "SS", spellings: "SS" },
    { country: "Spain", ctry: "ES", spellings: "ES España", booster: "2" },
    { country: "Sri Lanka", ctry: "LK", spellings: "LK ශ්‍රී ලංකා இலங்கை Ceylon" },
    { country: "Sudan", ctry: "SD", spellings: "SD السودان" },
    { country: "Suriname", ctry: "SR", spellings: "SR शर्नम् Sarnam Sranangron" },
    { country: "Svalbard and Jan Mayen", ctry: "SJ", spellings: "SJ", booster: "0.5" },
    { country: "Swaziland", ctry: "SZ", spellings: "SZ weSwatini Swatini Ngwane" },
    { country: "Sweden", ctry: "SE", spellings: "SE Sverige", booster: "1.5" },
    { country: "Switzerland", ctry: "CH", spellings: "CH Swiss Confederation Schweiz Suisse Svizzera Svizra", booster: "1.5" },
    { country: "Syrian Arab Republic", ctry: "SY", spellings: "SY Syria سورية" },
    { country: "Taiwan, Province of China", ctry: "TW", spellings: "TW 台灣 臺灣" },
    { country: "Tajikistan", ctry: "TJ", spellings: "TJ Тоҷикистон Toçikiston" },
    { country: "Tanzania, United Republic of", ctry: "TZ", spellings: "TZ" },
    { country: "Thailand", ctry: "TH", spellings: "TH ประเทศไทย Prathet Thai" },
    { country: "Timor-Leste", ctry: "TL", spellings: "TL" },
    { country: "Togo", ctry: "TG", spellings: "TG Togolese" },
    { country: "Tokelau", ctry: "TK", spellings: "TK", booster: "0.5" },
    { country: "Tonga", ctry: "TO", spellings: "TO" },
    { country: "Trinidad and Tobago", ctry: "TT", spellings: "TT" },
    { country: "Tunisia", ctry: "TN", spellings: "TN تونس" },
    { country: "Turkey", ctry: "TR", spellings: "TR Türkiye Turkiye" },
    { country: "Turkmenistan", ctry: "TM", spellings: "TM Türkmenistan" },
    { country: "Turks and Caicos Islands", ctry: "TC", spellings: "TC", booster: "0.5" },
    { country: "Tuvalu", ctry: "TV", spellings: "TV", booster: "0.5" },
    { country: "Uganda", ctry: "UG", spellings: "UG" },
    { country: "Ukraine", ctry: "UA", spellings: "UA Ukrayina Україна" },
    { country: "United Arab Emirates", ctry: "AE", spellings: "AE UAE الإمارات" },
    { country: "United Kingdom", ctry: "GB", spellings: "GB Great Britain England UK Wales Scotland Northern Ireland", booster: "2.5" },
    { country: "United States", booster: "3.5", ctry: "US", spellings: "US USA United States of America Murica" },
    { country: "United States Minor Outlying Islands", ctry: "UM", spellings: "UM" },
    { country: "Uruguay", ctry: "UY", spellings: "UY" },
    { country: "Uzbekistan", ctry: "UZ", spellings: "UZ Ўзбекистон O'zbekstan O‘zbekiston" },
    { country: "Vanuatu", ctry: "VU", spellings: "VU" },
    { country: "Venezuela", ctry: "VE", spellings: "VE" },
    { country: "Vietnam", ctry: "VN", spellings: "VN Việt Nam", booster: "1.5" },
    { country: "Virgin Islands, British", ctry: "VG", spellings: "VG", booster: "0.5" },
    { country: "Virgin Islands, U.S.", ctry: "VI", spellings: "VI", booster: "0.5" },
    { country: "Wallis and Futuna", ctry: "WF", spellings: "WF", booster: "0.5" },
    { country: "Western Sahara", ctry: "EH", spellings: "EH لصحراء الغربية" },
    { country: "Yemen", ctry: "YE", spellings: "YE اليمن" },
    { country: "Zambia", ctry: "ZM", spellings: "ZM" },
    { country: "Zimbabwe", ctry: "ZW", spellings: "ZW" }
  ];

  return {
    countries: countries,
    abbreviations: countries.map(country => country.ctry),
    immutableOptions: countries.map(country => {
      return new Immutable.Map({
        id: country.country,
        label: country.country,
        value: country.country,
      });
    }),
  }
});
